/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Credit_Note_InvalidInputs */

const en_error_credit_note_invalid = /** @type {(inputs: Error_Credit_Note_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The file cannot be the credit note of this inbound. Choose the file again and send it.`)
};

/**
* | output |
* | --- |
* | "The file cannot be the credit note of this inbound. Choose the file again and send it." |
*
* @param {Error_Credit_Note_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_credit_note_invalid = /** @type {((inputs?: Error_Credit_Note_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Credit_Note_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_credit_note_invalid(inputs)
});